import React, { useState, useEffect } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

export const DateTimeAttribute = ({
    value,
    required,
    defaultTime = 0,
    isDafaulttimeRequired,
    placeholder,
    readOnly,
    className,
    onChange,
    onBlur,
}: {
    value?: string;
    required?: boolean;
    placeholder?: string;
    readOnly?: boolean;
    className?: string;
    defaultTime?: number;
    isDafaulttimeRequired?: boolean;
    onChange: (value: string) => void;
    onBlur: () => void;
}) => {
    const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(null);

    useEffect(() => {
        if (isDafaulttimeRequired && !value) {
            const time = dayjs().add(defaultTime, 'minute');
            setSelectedDate(time);
            onChange(time.format('YYYY-MM-DD HH:mm'));
        } else if (value) {
            setSelectedDate(dayjs(value, 'YYYY-MM-DD HH:mm'));
        }
    }, [isDafaulttimeRequired, defaultTime, value, onChange]);

    const handleDateChange = (date: dayjs.Dayjs | null) => {
        setSelectedDate(date);
        onChange(date ? date.format('YYYY-MM-DD HH:mm') : '');
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
                value={selectedDate}
                onChange={handleDateChange}
                onClose={onBlur}
                format="DD-MM-YYYY HH:mm"
                timeSteps={{ minutes: 1 }}
                slotProps={{
                    textField: {
                        required,
                        placeholder,
                        className: `form-control form-control-sm ${className || ''}`.trim(),
                        inputProps: { readOnly },
                        sx: {
                            '& .MuiOutlinedInput-input': {
                                padding: '5px',
                            },
                        },
                    },
                }}
            />
        </LocalizationProvider>
    );
};


// import React from 'react';
// import DateTime from 'react-datetime';
// import 'react-datetime/css/react-datetime.css';
// import moment from 'moment';

// export const DateTimeAttribute = ({
//     value,
//     required,
//     placeholder,
//     readOnly,
//     className,
//     onChange,
//     onBlur,
// }: {
//     value?: string,
//     required?: boolean,
//     placeholder?: string,
//     readOnly?: boolean,
//     className?: string,
//     onChange: (value: any) => void,
//     onBlur: () => void
// }) => {
//     const handleDateChange = (date: any) => {
//         const parsedDate = moment(date, 'DD-MM-YYYY HH:mm', true);
//         onChange(parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD HH:mm') : '');
//     };

//     return (
//         <DateTime
//             value={value ? moment(value, 'YYYY-MM-DD HH:mm').format('DD-MM-YYYY HH:mm') : ''}
//             dateFormat="DD-MM-YYYY"
//             timeFormat="HH:mm"
//             inputProps={{
//                 required,
//                 readOnly,
//                 placeholder,
//                 className: `form-control form-control-sm ${className || ''}`,
//                 onBlur
//             }}
//             onChange={handleDateChange}
//         />
//     );
// };
